<template>
  <el-upload
    :drag="drag"
    :action="url"
    :headers="{
      'Authorization': token
    }"
    :data="data"
    :on-success="handleSuccess"
    :on-remove="handleRemove"
    :on-error="handleError"
    :file-list="fileList"
    :list-type="listType"
    :show-file-list="showFileList"
    ref="upload"
  >
    <slot name="content">
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
    </slot>
  </el-upload>
</template>

<script>
import userInfoHelper from 'common/userInfo';

export default {
  name: 'Upload',
  props: {
    value: String,
    data: Object,
    showFileList: { type: Boolean, default: true },
    listType: { type: String, default: 'picture' },
    url: { type: String, default: '/admin/common/upload' },
    drag: { type: Boolean, default: true },
  },
  data() {
    return {
      token: userInfoHelper.get().accessToken,

    };
  },
  computed: {

    fileList() {
      return this.value
        ? this.value.split(',').map(item => {
            return {
              name: item.split('/').reverse()[0],
              url: item
            };
          })
        : [];
    }
  },
  methods: {
    handleSuccess(file) {
      if (file.code === 0) {
          this.$emit('change', file.data);
          this.$emit('input', file.data);
          this.$parent.$emit('el.form.change', file.data);
      } else {
        this.$message.error(file.msg);
        this.handleRemove();
      }
    },
    handleError() {
      this.handleRemove();
    },
    handleRemove() {
      this.$refs['upload'].clearFiles();
      this.$emit('change', '');
      this.$emit('input', '');
      this.$parent.$emit('el.form.change', '');
    }
  },
  created(){
     // console.log(this.limitNumber)
  }
};
</script>

<style lang="less" scoped>
</style>
